// extracted by mini-css-extract-plugin
export default {"modalContainer":"styles_modalContainer__DjI8Q","modalContent":"styles_modalContent__Hwegd"};